import {Component} from '@angular/core'

@Component({
  selector: 'client-configuration-page',
  template: `
    <router-outlet></router-outlet>
  `
})
export class ClientConfigurationPage {}
